import { Seo } from "../components/Seo";
import { Hero } from "../components/home/Hero";
import { FeaturedVehicles } from "../components/home/FeaturedVehicles";
import { LatestInventory } from "../components/home/LatestInventory";
import { SourcingSection } from "../components/home/SourcingSection";
import { WhySection } from "../components/home/WhySection";
import { ExportSection } from "../components/home/ExportSection";
import { CompanyIntro } from "../components/home/CompanyIntro";
import { ContactCta } from "../components/home/ContactCta";
import { useSiteSettings } from "../lib/siteSettings";
import { useLocale } from "../i18n";
import { useApi } from "../lib/api";

const SECTIONS = { featured: FeaturedVehicles, latest: LatestInventory, sourcing: SourcingSection, why: WhySection,
  export: ExportSection, company: CompanyIntro, contact: ContactCta };
const DEFAULT_ORDER = Object.keys(SECTIONS).map((id) => ({ id, visible: true }));
const STOCK_SECTIONS = ["featured", "latest"];

export default function Home() {
  const s = useSiteSettings();
  const lang = useLocale();
  const stock = useApi("/vehicles", { limit: 1 });
  const noStock = stock.data?.total === 0;
  const hp = s.homepage || {};
  const order = (hp.sections?.length ? hp.sections : DEFAULT_ORDER)
    .filter((x) => x.visible && SECTIONS[x.id] && !(noStock && STOCK_SECTIONS.includes(x.id)));
  const hero = hp.hero?.[lang] || {};
  return (
    <div data-testid="home-page">
      <Seo description={hero.subtitle || undefined} image={hp.hero_image?.variants?.large} />
      <Hero />
      {s.loaded && order.map(({ id }, i) => {
        const Section = SECTIONS[id];
        return <Section key={id} index={String(i + 1).padStart(2, "0")} />;
      })}
    </div>
  );
}
